import { Box, Icon, IconButton, Input, InputGroup, Text } from '@chakra-ui/react'
import { CloseIcon, SearchIcon } from '@src/components/sco/icons'
import { useDebounce } from '@uidotdev/usehooks'
import React, { useEffect, useState } from 'react'

type KeywordSearchInputProps = {
  defaultValue?: string
  icon?: any
  onChange: (value) => any
  placeholder?: string
  label?: string
}

export const KeywordInput = (props: KeywordSearchInputProps) => {
  const [value, setValue] = useState(props.defaultValue || '')
  const debouncedKeywords = useDebounce(value, 100)

  useEffect(() => {
    props.onChange(value)
  }, [debouncedKeywords])

  const handleSubmit = (e = null) => {
    e.preventDefault()
    props.onChange(value)
  }

  const handleChange = e => {
    setValue(e.target.value)
  }

  return (
    <Box width={'full'}>
      {props.label && (
        <Text marginBottom={4} textStyle={'label2xs'}>
          {props.label}
        </Text>
      )}
      <InputGroup
        startElement={<Icon as={props.icon || SearchIcon} color={'colorPalette.fg/60'} />}
        endElement={
          value ? (
            <IconButton
              aria-label={'Clear'}
              size={'xs'}
              variant={'ghost'}
              onClick={() => {
                setValue('')
                props.onChange('')
              }}
            >
              <CloseIcon boxSize={2} />
            </IconButton>
          ) : undefined
        }
      >
        <Input
          paddingLeft={8}
          placeholder={props.placeholder || 'Search...'}
          type={'text'}
          value={value || ''}
          onChange={handleChange}
        />
      </InputGroup>
    </Box>
  )
}
